import { render, staticRenderFns } from "./SpaceFacilitiesPage.vue?vue&type=template&id=1f2acdf3&scoped=true"
import script from "./SpaceFacilitiesPage.vue?vue&type=script&lang=ts"
export * from "./SpaceFacilitiesPage.vue?vue&type=script&lang=ts"
import style0 from "./SpaceFacilitiesPage.vue?vue&type=style&index=0&id=1f2acdf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2acdf3",
  null
  
)

export default component.exports